const getters = {
  getRecipients: state => state.recipients,
  getRecipient: state => state.recipient,
  getRecipToCreate: state => state.recipToCreate,
  getRecipToDelete: state => state.recipToDelete,
  getRecipCount: state => state.totalRecips,
  getIsRecipientLoading: state => state.isRecipientsLoading,
  getRecipientError: state => state.recipientError,
};

export default getters;
